<div [hidden]="!loaded" class="container">
  <ng-container *ngFor="let cat of categories; let isLast = last">
    <section>
      <h3>{{ cat }}</h3>
      <div class="shortcuts">
        <div class="shortcut" *ngFor="let short of shortcuts[cat]">
          <div class="letters">
            <div class="letter" *ngFor="let key of short.keys">
              <span title="{{ key | uppercase }}"> {{ key }} </span>
            </div>
          </div>
          <pre>{{ short.description }}</pre>
        </div>
      </div>
    </section>
    <div *ngIf="!isLast" class="vertical-separator"></div>
  </ng-container>
</div>
